import { createSlice } from '@reduxjs/toolkit';
const isLoadingSlice = createSlice({
    name: 'isLoading',
    initialState: 0,
    reducers: {
        startLoading: (state, action) => {
            const setExperienceLoadingState = action?.payload?.setLoadingState;

            if (setExperienceLoadingState) {
                setExperienceLoadingState(true);
            }

            return state + 1;
        },
        stopLoading: (state, action) => {
            const setExperienceLoadingState = action?.payload?.setLoadingState;

            if (setExperienceLoadingState) {
                setExperienceLoadingState(false);
            }

            return state > 0 ? state - 1 : 0;
        }
    },
});
export const {
    startLoading,
    stopLoading,
} = isLoadingSlice.actions;
export const selectIsloading = state => state.isLoading > 0;
export default isLoadingSlice.reducer;
